import { OVERLAY_INSTANCES } from 'util/project/overlay-instances';

export const MOBILE_SWITCHER_STATES = Object.freeze({ LIST: 'LIST', MAP: 'MAP' });

export const OVERLAY_CONFIGS = {
    galleryOverlay({ imageIdx, images, open }) {
        if (open) {
            return {
                id: OVERLAY_INSTANCES.GALLERY_OVERLAY,
                facets: ['gallery-overlay'],
                component: 'dyn-gallery-overlay',
                transition: 'trs-simple-fade',
                props: {
                    imageIdx,
                    images,
                },
            };
        }

        return {
            id: OVERLAY_INSTANCES.GALLERY_OVERLAY,
            transition: 'trs-simple-fade',
        };
    },
    homeOverlay({ open, animate }) {
        if (open) {
            return {
                id: OVERLAY_INSTANCES.HOME_OVERLAY,
                facets: ['home-overlay'],
                component: 'dyn-home-overlay',
                transition: animate ? 'trs-simple-fade' : '',
                props: {},
            };
        }

        return {
            id: OVERLAY_INSTANCES.HOME_OVERLAY,
            transition: 'trs-simple-fade',
        };
    },
    menuSidebar({ open }) {
        if (open) {
            return {
                id: OVERLAY_INSTANCES.MENU_SIDEBAR,
                facets: ['menu-sidebar'],
                component: 'dyn-menu-sidebar',
                transition: 'trs-slide-right',
                props: {},
            };
        }

        return {
            id: OVERLAY_INSTANCES.MENU_SIDEBAR,
            transition: 'trs-slide-right',
        };
    },
};
